import { useTasksStore } from "@nextories/vue-tasks/src/store/tasksStore";
import { useUsersStore } from "@nextories/vue-tasks/src/store/usersStore";
import type { FilterQuery } from "@nextories/vue-tasks/src/types/Filters";
import filterHelper from '@nextories/vue-tasks/src/utils/helpers/common/filter';
import tasksHelper from '@nextories/vue-tasks/src/utils/helpers/tasks';

export const pluginDiaryStore = {
  actions: {
    setInitialFilters(query?: FilterQuery) {
      const { baseMainFilters } = this;
      const filterUsers = useUsersStore().$state.filterUsers;
      const { myTasks } = filterUsers;
      const status = useTasksStore().$state.listStatusAvailable;
      // Avoid repetitive deep cloning, create subFilters in a clear way.
      const subFilters = {
        ...filterUsers,
        ...filterHelper.setSubFilterEnabled('diary', myTasks, query),
        ...useTasksStore().$state.listTasksType,
        ...tasksHelper.urgentFilter(),
        ...tasksHelper.disputeFilter(),
      };
      baseMainFilters.diary = {
        ...baseMainFilters.diary,
        ...this.mainSettings,
        id: 'diary',
        isAuto: true,
        hasCounter: false,
        enabled: true,
        type: 'main-enabled',
        icon: 'list',
        query: {
          status,
        },
        queries: {
          post: {
            status,
          },
        },
        subFilters: subFilters,  // Set subFilters directly here
      };
      // Update the base main filters and trigger the methods to set them.
      this.baseMainFilters = baseMainFilters;
      // Avoid redundant deep cloning
      this.setMainFilters(baseMainFilters);
      this.setActivatedFilter(this.mainFilters.diary);
    }
  },
};
